import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS, Document } from '@contentful/rich-text-types'
import {
    Blockquote,
    CustomHtml,
    Figure,
    OrderedList,
    Paragraph,
    RTHeading,
    Separator,
    UnorderedList,
} from 'components/RichText'
import { slugifyText } from 'services'

import parseImage from './image'

/** Transform a Contentful RichText document into React components. */
export default function parseRichText(richText: Document) {
    return documentToReactComponents(richText, {
        renderNode: {
            [BLOCKS.EMBEDDED_ENTRY]: (node) => {
                /** Handle custom components */
                const contentType = node.data.target.sys.contentType.sys.id

                if (contentType === 'htmlEmbed') {
                    const html = node.data.target.fields.html as string
                    return <CustomHtml html={html} />
                }

                if (process.env.ENV === 'development') {
                    console.log('Unrecognize content type:', contentType)
                }

                return null
            },
            [BLOCKS.EMBEDDED_ASSET]: (node) => {
                /** Handle pictures */
                const image = parseImage(node.data.target)
                const { title, description, url, size } = image
                return <Figure href={url} title={title} text={description} size={size} />
            },
            [BLOCKS.HEADING_2]: (_, children) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const id = children[0] as string
                return (
                    <RTHeading tag="h2" id={slugifyText(id)}>
                        {children}
                    </RTHeading>
                )
            },
            [BLOCKS.HEADING_3]: (_, children) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const id = children[0] as string
                return (
                    <RTHeading tag="h3" id={slugifyText(id)}>
                        {children}
                    </RTHeading>
                )
            },
            [BLOCKS.OL_LIST]: (_, children) => {
                return <OrderedList>{children}</OrderedList>
            },
            [BLOCKS.UL_LIST]: (_, children) => {
                return <UnorderedList>{children}</UnorderedList>
            },
            [BLOCKS.LIST_ITEM]: (_, children) => <li>{children}</li>,
            [BLOCKS.PARAGRAPH]: (_, children) => <Paragraph>{children}</Paragraph>,
            [BLOCKS.QUOTE]: (_, children) => <Blockquote>{children}</Blockquote>,
            [BLOCKS.HR]: () => <Separator />,
        },
    })
}
